import { Box, Divider } from '@material-ui/core';
import React from 'react';
import AdditionalInfoPanel from './panels/AdditionalInfoPanel';
import CharacteristicsPanel from './panels/CharacteristicsPanel';
import DescriptionPanel from './panels/DescriptionPanel';
import McsPanel from './panels/McsPanel';

interface RightInfoTabProps {
    selected: any;
}

const RightInfoTab: React.FC<RightInfoTabProps> = ({ selected }) => {
    return (
        <Box>
            <DescriptionPanel selected={selected} />

            <Divider />

            <CharacteristicsPanel selected={selected} />

            <Divider />

            <McsPanel selected={selected} />

            <Divider />

            <AdditionalInfoPanel selected={selected} />

            <Divider />
        </Box>
    );
};

export default RightInfoTab;
